import image1 from "../assets/appimg1.png";
import image2 from "../assets/appimg2.png";
import image3 from "../assets/appimg3.png";

export const appData = [
  {
    image: image1,
    review:
      "React Native app with appwrite functional login and register with suitable validations. Modern looking app. Upload, view, search and also login and register",
    name: "Video App",
    used: "ReactNative / Nativewind / Appwrite",
    link: "https://github.com/harsha-99-tech/Video-App",
  },
  {
    image: image2,
    review:
      "Flutter android community app for post technical problems and share the solutions with everyone and this works like stack overflow. And used firebase for authentication and other backend services",
    name: "Q&A App",
    used: "Flutter / Firebase",
    link: "https://github.com/TecBet/QnA_App",
  },
  {
    image: image3,
    review:
      "React Native app with Firebase integration. Uploading books, reading and also requesting books. User friendly interface and useful functions added. To bring books to your mobile phone and share boos with others",
    name: "E-Library App",
    used: "ReactNative / Nativewind / Firebase",
    link: "https://github.com/harsha-99-tech/E-Library",
  },
];
